import React from 'react'

export default class Footer extends React.Component {

    render() {
        return <div /* style={{marginTop: 20}} */ className="footer">
            <p className="m-0 text-center text-white" >
                Copyright &copy; 2019-2026 <a href="http://www.dayalbagh.org.in/" target="_blank"
                    className="text-white"><u>Ra</u> <u>Dha</u> <u>Sva</u> <u>Aa</u> <u>Mi</u> Satsang Sabha, Dayalbagh, Agra, UP - 282005, INDIA</a>
            </p>
        </div>
    }

}
